module.exports = __webpack_public_path__ + "static/bradesco-3-6901a50b0aeabc4510020420c386ba56.jpg";